const FETCH_ALL_PERSONS = 'FETCH_ALL_PERSONS';
const FILTER_CLEAR_ALL = 'FILTER_CLEAR_ALL';
const QUERY_CHANGE = 'QUERY_CHANGE';
const FILTER_CHANGE = 'FILTER_CHANGE';
const CLEAR_ALL = 'CLEAR_ALL';
const PAGINATION_CHANGE = 'PAGINATION_CHANGE';
const FILTER_SET = 'FILTER_SET';
const FILTER_UPDATE = 'FILTER_UPDATE';
const MULTIPLE_FILTERS_UPDATE = 'MULTIPLE_FILTERS_UPDATE';
const FILTER_CLEAR = 'FILTER_CLEAR';
const FILTER_CLEAR_GROUP = 'FILTER_CLEAR_GROUP';

const IS_LOADING = 'IS_LOADING';
const FETCH_MORE_PERSONS = 'FETCH_MORE_PERSONS';
const GET_PERSON_BY_ID = 'GET_PERSON_BY_ID';
const UPDATE_PERSONS_FOR_MESSAGES = 'UPDATE_PERSONS_FOR_MESSAGES';
const GET_LINKEDIN_DATA = 'GET_LINKEDIN_DATA';
const TOGGLE_LEAD = 'TOGGLE_LEAD';
const LAST_MESSAGES = 'LAST_MESSAGES';
const GET_MESSAGE_BY_PERSON = 'GET_MESSAGE_BY_PERSON';
const TOGGLE_GROUP_MODAL_MENU = 'TOGGLE_GROUP_MODAL_MENU';
const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU';
const LINKEDIN_TOKEN_VALIDATED = 'LINKEDIN_TOKEN_VALIDATED';
const UPDATE_EXTERNAL_IDS = 'UPDATE_EXTERNAL_IDS';
const UPDATE_ME = 'UPDATE_ME';
const CONNECT_ON_LINKEDIN = 'CONNECT_ON_LINKEDIN';
const SEND_MESSAGE = 'SEND_MESSAGE';
const INBOX_TEXT_CHANGED = 'INBOX_TEXT_CHANGED ';
const UPDATE_PERSONS = 'UPDATE_PERSONS ';

const SETTINGS_VALIDATE_EMAIL_PENDING = 'SETTINGS_VALIDATE_EMAIL_PENDING';
const SETTINGS_VALIDATE_EMAIL_SUCCESS = 'SETTINGS_VALIDATE_EMAIL_SUCCESS';
const SETTINGS_VALIDATE_EMAIL_ERROR = 'SETTINGS_VALIDATE_EMAIL_ERROR';

const SETTINGS_CHANGED = 'SETTINGS_CHANGED';
const SETTINGS_SAVE_PENDING = 'SETTINGS_SAVE_PENDING';
const SETTINGS_SAVE_SUCCESS = 'SETTINGS_SAVE_SUCCESS';
const SETTINGS_SAVE_ERROR = 'SETTINGS_SAVE_ERROR';
const SETTINGS_CHANGE_EMAIL = 'SETTINGS_CHANGE_EMAIL';
const SETTINGS_EMAIL_CHANGED = 'SETTINGS_EMAIL_CHANGED';

const SELECT_AGENDA_DAY = 'SELECT_AGENDA_DAY';
const TOGGLE_AGENDA_FILTER = 'TOGGLE_AGENDA_FILTER';
const SELECT_AGENDA_FILTER_CAT = 'SELECT_AGENDA_FILTER_CAT';
const SET_AGENDA_SESSIONS = 'SET_AGENDA_SESSIONS';
const SET_AGENDA_SESSIONS_MAP = 'SET_AGENDA_SESSIONS_MAP';
const UPDATE_AGENDA_SESSIONS = 'UPDATE_AGENDA_SESSIONS';
const IS_AGENDA_LOADING = 'IS_AGENDA_LOADING';
const CLIENT_NAVIGATION = 'CLIENT_NAVIGATION';
const SET_AGENDA_SETTINGS = 'SET_AGENDA_SETTINGS';
const SET_AGENDA_SPEAKERS = 'SET_AGENDA_SPEAKERS';
const SET_AGENDA_DAYS = 'SET_AGENDA_DAYS';
const SET_VIRTUAL_SESSION_DETAILS = 'SET_VIRTUAL_SESSION_DETAILS';
const SET_CURRENT_RECORD_URL = 'SET_CURRENT_RECORD_URL';

const SET_MARKERS = 'SET_MARKERS';
const ADD_AGENDA_MARKER = 'ADD_AGENDA_MARKER';
const CHANGE_ACTIVE_TAB = 'CHANGE_ACTIVE_TAB';
const CHANGE_VIEW_MODE = 'CHANGE_VIEW_MODE';

const REMOVE_AGENDA_MARKER = 'REMOVE_AGENDA_MARKER';
const UPDATE_SPEAKER_LIKES = 'UPDATE_SPEAKER_LIKES';
const RESET_SPEAKER_DATA = 'RESET_SPEAKER_DATA';
const SET_AGENDA_SPEAKER_SESSIONS = 'SET_AGENDA_SPEAKER_SESSIONS';
const SET_AGENDA_SPEAKER = 'SET_AGENDA_SPEAKER';
const SET_AGENDA_SPEAKER_LIKE_COUNT = 'SET_AGENDA_SPEAKER_LIKE_COUNT';
const IS_SPEAKER_LOADING = 'IS_SPEAKER_LOADING';
const START_UPDATE_LIKE_SPEAKER_STATUS = 'START_UPDATE_LIKE_SPEAKER_STATUS';
const FAILED_UPDATE_LIKE_SPEAKER_STATUS = 'FAILED_UPDATE_LIKE_SPEAKER_STATUS';

const SET_AGENDA_SESSION = 'SET_AGENDA_SESSION';
const SET_AGENDA_SESSION_ERROR = 'SET_AGENDA_SESSION_ERROR';
const SET_AGENDA_SESSION_SPEAKERS = 'SET_AGENDA_SESSION_SPEAKERS';
const RESET_SESSION_DATA = 'RESET_SESSION_DATA';
const SET_AGENDA_SESSION_RATE = 'SET_AGENDA_SESSION_RATE';
const SESSION_REGISTRATION_STATUS_CHANGED = 'SESSION_REGISTRATION_STATUS_CHANGED';
const REGISTERED_SESSION_IDS_FETCHED = 'REGISTERED_SESSION_IDS_FETCHED';
const SET_SESSION_FULL_REGISTRATION = 'SET_SESSION_FULL_REGISTRATION';
const SET_SESSION_OVERLAPPING_REGISTRATION = 'SET_SESSION_OVERLAPPING_REGISTRATION';
const SET_SESSION_UPCOMING_SESSIONS = 'SET_SESSION_UPCOMING_SESSIONS';

const SESSION_SPONSORS_FETCHED = 'SESSION_SPONSORS_FETCHED';
const SET_SLIDER_SESSIONS = 'SET_SLIDER_SESSIONS';
const USER_TICKETS_FETCHED = 'USER_TICKETS_FETCHED';
const FETCH_SESSION_FOR_REGISTRATION_BY_TICKET = 'FETCH_SESSION_FOR_REGISTRATION_BY_TICKET';
const FETCH_SESSION_REGISTERED_BY_TICKET = 'FETCH_SESSION_REGISTERED_BY_TICKET';
const USER_SELECT_TICKET = 'USER_SELECT_TICKET';
const USER_UNSELECT_TICKET = 'USER_UNSELECT_TICKET';
const TICKET_SELECTION_POP_ACTION = 'TICKET_SELECTION_POP_ACTION';
const SAVE_A_SEAT_REQUEST = 'SAVE_A_SEAT_REQUEST';
const SAVE_A_SEAT_REQUEST_END = 'SAVE_A_SEAT_REQUEST_END';
const SAVE_A_SEAT_ERROR = 'SAVE_A_SEAT_ERROR';
const SET_SCROLL_TO_SESSION_BROADCAST = 'SET_SCROLL_TO_SESSION_BROADCAST';

// Login
const SHOW_LOGIN = 'SHOW_LOGIN';
const HIDE_LOGIN = 'HIDE_LOGIN';
const SHOW_LOGIN_SPINNER = 'SHOW_LOGIN_SPINNER';
const HIDE_LOGIN_SPINNER = 'HIDE_LOGIN_SPINNER';
const SET_LOGIN_OFFSET_TOP = 'SET_LOGIN_OFFSET_TOP';
const SET_LOGIN_SPINNER_ORIGIN = 'SET_LOGIN_SPINNER_ORIGIN';
const HIDE_SSO_EMAIL_ERROR_MODAL = 'HIDE_SSO_EMAIL_ERROR_MODAL';
const SHOW_SSO_EMAIL_ERROR_MODAL = 'SHOW_SSO_EMAIL_ERROR_MODAL';

module.exports = {
    FETCH_ALL_PERSONS,
    QUERY_CHANGE,
    FILTER_CHANGE,
    IS_LOADING,
    FETCH_MORE_PERSONS,
    CLEAR_ALL,
    PAGINATION_CHANGE,
    FILTER_UPDATE,
    MULTIPLE_FILTERS_UPDATE,
    FILTER_SET,
    FILTER_CLEAR,
    FILTER_CLEAR_GROUP,

    GET_PERSON_BY_ID,
    UPDATE_PERSONS_FOR_MESSAGES,
    GET_LINKEDIN_DATA,
    TOGGLE_LEAD,
    LAST_MESSAGES,
    GET_MESSAGE_BY_PERSON,
    TOGGLE_GROUP_MODAL_MENU,
    TOGGLE_MOBILE_MENU,
    LINKEDIN_TOKEN_VALIDATED,
    UPDATE_EXTERNAL_IDS,
    UPDATE_ME,
    CONNECT_ON_LINKEDIN,
    FILTER_CLEAR_ALL,
    SEND_MESSAGE,
    INBOX_TEXT_CHANGED,
    UPDATE_PERSONS,

    SETTINGS_VALIDATE_EMAIL_PENDING,
    SETTINGS_VALIDATE_EMAIL_SUCCESS,
    SETTINGS_VALIDATE_EMAIL_ERROR,

    SETTINGS_CHANGED,
    SETTINGS_SAVE_PENDING,
    SETTINGS_SAVE_SUCCESS,
    SETTINGS_SAVE_ERROR,
    SETTINGS_EMAIL_CHANGED,

    SELECT_AGENDA_DAY,
    TOGGLE_AGENDA_FILTER,
    SELECT_AGENDA_FILTER_CAT,
    SET_AGENDA_SESSIONS,
    SET_AGENDA_SESSIONS_MAP,
    UPDATE_AGENDA_SESSIONS,
    IS_AGENDA_LOADING,
    CLIENT_NAVIGATION,
    ADD_AGENDA_MARKER,
    REMOVE_AGENDA_MARKER,
    SET_MARKERS,
    SET_AGENDA_SETTINGS,
    SET_AGENDA_SPEAKERS,
    SET_AGENDA_DAYS,
    SET_VIRTUAL_SESSION_DETAILS,
    SET_CURRENT_RECORD_URL,

    UPDATE_SPEAKER_LIKES,
    IS_SPEAKER_LOADING,
    SET_AGENDA_SPEAKER_SESSIONS,
    SET_AGENDA_SPEAKER,
    SET_AGENDA_SPEAKER_LIKE_COUNT,
    RESET_SPEAKER_DATA,

    SET_AGENDA_SESSION,
    SET_AGENDA_SESSION_ERROR,
    RESET_SESSION_DATA,
    SET_AGENDA_SESSION_SPEAKERS,
    SET_AGENDA_SESSION_RATE,
    SESSION_REGISTRATION_STATUS_CHANGED,
    REGISTERED_SESSION_IDS_FETCHED,
    CHANGE_ACTIVE_TAB,
    CHANGE_VIEW_MODE,
    SESSION_SPONSORS_FETCHED,
    START_UPDATE_LIKE_SPEAKER_STATUS,
    FAILED_UPDATE_LIKE_SPEAKER_STATUS,
    SET_SLIDER_SESSIONS,
    SET_SESSION_FULL_REGISTRATION,
    SET_SESSION_OVERLAPPING_REGISTRATION,
    SET_SESSION_UPCOMING_SESSIONS,
    USER_TICKETS_FETCHED,
    USER_SELECT_TICKET,
    USER_UNSELECT_TICKET,
    FETCH_SESSION_FOR_REGISTRATION_BY_TICKET,
    FETCH_SESSION_REGISTERED_BY_TICKET,
    TICKET_SELECTION_POP_ACTION,
    SAVE_A_SEAT_REQUEST,
    SAVE_A_SEAT_REQUEST_END,
    SAVE_A_SEAT_ERROR,
    SET_SCROLL_TO_SESSION_BROADCAST,

    SET_LOGIN_OFFSET_TOP,
    SHOW_LOGIN,
    HIDE_LOGIN,
    SHOW_LOGIN_SPINNER,
    HIDE_LOGIN_SPINNER,
    SET_LOGIN_SPINNER_ORIGIN,
    HIDE_SSO_EMAIL_ERROR_MODAL,
    SHOW_SSO_EMAIL_ERROR_MODAL,
};
